import { render, staticRenderFns } from "./OfertaDuvidas.vue?vue&type=template&id=05fbe4d0&"
import script from "./OfertaDuvidas.vue?vue&type=script&lang=js&"
export * from "./OfertaDuvidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports